// The ways to the march (docs/plans/2026-10-18-shared-metro.md, section 7). For now the metro is the only way to travel;
// the others show on the phone, locked, as in development. The cab is built (story mode's ride), so a developer can
// open it with ?modes=cab; nothing else unlocks it.

export type ModeId = 'metro' | 'cab' | 'bus' | 'walk';
export interface Mode { id: ModeId; en: string; hi: string; pitch: string }

export const MODES: Mode[] = [
  { id: 'metro', en: 'Metro', hi: 'मेट्रो', pitch: 'The Yellow Line, with your kafila' },
  { id: 'cab', en: 'Cab', hi: 'कैब', pitch: 'Door to door, if the roads are clear' },
  { id: 'bus', en: 'Bus', hi: 'बस', pitch: 'Slow, cheap, and full of people' },
  { id: 'walk', en: 'Walk', hi: 'पैदल', pitch: 'On foot from wherever you are' },
];

export const LOCKED = { en: 'In development', hi: 'जल्द आ रहा है' };

/** The modes a player can pick: the metro, and the built ones a developer opened with ?modes= (comma separated). */
export function openModes(search: string): Set<ModeId> {
  const asked = (new URLSearchParams(search).get('modes') ?? '').split(',');
  return new Set<ModeId>(['metro', ...(asked.includes('cab') ? ['cab' as const] : [])]);
}
